export const popupHeaderHeight = 68;
